require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/table.css');
require('ta-semantic-ui/semantic/dist/components/item.css');
require('ta-semantic-ui/semantic/dist/components/card.css');
require('styles/App.scss');

import React from 'react';
import Masthead from 'ta-react-masthead';
import Tracking from 'ta-react-tracking';
import StandaloneShareButtons from 'components/standaloneShareButtons/StandaloneShareButtons.component';
import CopyrightNotice from 'components/copyrightNotice/CopyrightNotice.component';

class AppComponent extends React.Component {
  render() {
    return (
      <div className='index'>
        <Masthead />
        <div className='ui vertical top segment'
             style={{backgroundColor: 'white'}}>
          <div className='ui text container'>
            <h1 className='ui header'>Wo Zürichs Chihuahua-Land ist</h1>
            <p className='ta lead'>Die interessantesten Zahlen zu Zürichs
              Hunden, kommentiert von Hunde-Verhaltenstherapeutin Marlen Maurer.
              Sie findet, dass auch kleine Hunde nicht in die Stadt gehören.</p>
            <p className='ta author'>Von Klaudia Meisterhans (Grafik), Barnaby
              Skinner (Interview) und Kaspar Manz (Onlineumsetzung)</p>
          </div>

          <div className='ui one column grid'>
            <div className='mobile only column'>
              <img src={require('./img/mobile-top.svg')}
                   alt=''
                   className='ui fluid image'/>
            </div>
          </div>

        </div>

        <div className='ui vertical chart segment'>
          <div className='ui text container'>
            <div className='ui one column grid'>
              <div className='mobile only column'>
                <h2 className='ui infographic inverted dividing tiny header'>
                  Die Beliebtesten
                  <div className='sub header'>
                    In Zürich sind aktuell <strong> 6930 Hunde </strong> und
                    <strong> 306 Rassen </strong> registriert (alle Zahlen
                    2015).
                  </div>
                </h2>
                <img src={require('./img/mobile-chart.svg')}
                     alt=''
                     className='ui fluid image'/>
              </div>

              <div className='mobile hidden column'>
                <h2 className="ui infographic tiny dividing header">
                  Die Beliebtesten
                </h2>

                <img src={require('./img/desktop-chart.svg')}
                     alt=''
                     className='ui fluid image'/>

                <div className='ui inverted basic infographic segment'>
                  In Zürich sind aktuell <strong> 6930 Hunde </strong> und
                  <strong> 306 Rassen </strong> registriert (alle Zahlen 2015).
                </div>

              </div>

            </div>
          </div>
        </div>

        {
          //region Anteile
        }

        <div className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui stackable grid'>
              <div className='ten wide computer eight wide tablet column'>
                <div className="ui stackable grid">
                  <div className="eight wide computer sixteen wide tablet column">
                    <h2 className='ui infographic inverted tiny dividing header'>
                      Wo die Chihuahuas leben
                      <div className='sub header'>Anteile Chihuahuas an der
                        Hundepopulation
                      </div>
                    </h2>

                    <img src={require('./img/chihuahua-population.svg')}
                         alt=''/>
                  </div>
                  <div className="eight wide computer sixteen wide tablet column">
                    <h2 className='ui infographic inverted tiny dividing header'>
                      Wo die Labradore leben
                      <div className='sub header'>Labrador-Anteil an der
                        Hundepopulation
                      </div>
                    </h2>

                    <img src={require('./img/labrador-population.svg')}
                         alt=''
                         className='ui fluid image'/>
                  </div>

                </div>

              </div>
              <div className='six wide computer eight wide tablet column'>

                <div className='ui inverted basic vertical text segment '>
                  <p className='ta interview question'>Warum ist der Chihuahua
                    die beliebteste Hunderasse in der Stadt Zürich?</p>

                  <p className='ta interview'>Viele Wohnungsvermieter lassen
                    grosse Hunde nicht zu. Allein deswegen sind kleinere Hunde
                    viel gefragter. Genauso wichtig sind die Kosten. Nehmen Sie
                    den Transport. Im Zürcher Regionalverkehr kostet das
                    Jahresticket für grosse Hunde 1610 Franken. Kleine Hunde
                    können in Taschen oder Körben gratis mitgeführt werden. Die
                    Anzahl der kleinen Hunde wird in Zürich wohl zunehmen: Seit
                    Anfang Jahr müssen Kleinhundehalter nicht einmal mehr den
                    Sachkundenausweis vorzeigen, der bisher schweizweit Pflicht
                    war. Für grosse Hunde müssen hingegen bis zu 20 Lektionen in
                    einer Hundeschule absolviert werden. </p>

                  <p className='ta interview question'>Es gibt doch andere
                    kleine Hunde.</p>

                  <p className='ta interview'>Laut der Datenbank Amicus liegt
                    der Chihuahua nicht nur in Zürich, sondern schweizweit auf
                    Platz eins. Der Chihuahua lässt sich überall mitnehmen: im
                    Auto, ja sogar im Flugzeug. Die Häufung der Rasse hat sicher
                    auch mit den vielen Celebrities zu tun, die sich diesen Hund
                    halten. Was früher der Zwergpudel war, ist heute der
                    Chihuahua.</p>

                </div>

              </div>
            </div>
          </div>

        </div>

        {
          //endregion

          //region Alter
        }

        <div className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui grid mobile reversed stackable'>


              <div className='six wide computer eight wide tablet column'>
                <div className='ui inverted basic vertical text segment'>
                  <p className='ta interview question'>Chihuahuas sind nicht in
                    jeder Altersklasse die beliebtesten. Leute zwischen 50 und
                    60 halten sich eher einen Labrador Retriever. Und die über
                    80-Jährigen lieben den Pudel. Haben Sie eine Erklärung
                    dafür?</p>

                  <p className='ta interview'>Ich bin Ende der 70er-Jahre
                    aufgewachsen. Da war neben dem Appenzeller der Pudel sehr
                    beliebt. In den 80ern und 90ern war es dann der
                    Cocker-Spaniel. Es ist mit dem Hund wie mit der Mode: Die
                    Trends kommen und gehen. </p>

                </div>
              </div>

              <div className='ten wide computer eight wide tablet column'>
                <div className="ui stackable grid">
                  <div className="eight wide computer sixteen wide tablet column">
                    <h2 className='ui tiny inverted infographic dividing header'>
                      Beliebteste Rasse nach Alter
                      <div className='sub header'>Anzahl Hunde nach Altersgruppe
                        der Halter
                      </div>
                    </h2>

                    <img src={require('./img/race-age.svg')}
                         alt=''
                         className='ui fluid image'/>
                  </div>
                  <div className="eight wide computer sixteen wide tablet column">
                    <h2 className='ui tiny inverted infographic dividing header'>
                      Alter der Hundehalter
                      <div className='sub header'>Anzahl Hunde nach
                        Altersgruppen
                      </div>
                    </h2>

                    <img src={require('./img/age.svg')}
                         alt=''
                         className='ui fluid image'/>
                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>

        {
          //endregion

          //region Gender
        }

        <div className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui grid stackable'>
              <div className='six wide computer eight wide tablet column'>
                <h2 className='ui tiny inverted infographic header dividing'>
                  Geschlecht der Hundehalter
                  <div className='sub header'>In Zürich sind 6275 Hundehalter
                    registriert
                  </div>
                </h2>

                <img src={require('./img/gender.svg')}
                     alt=''
                     className='ui fluid image'/>

              </div>
              <div className='ten wide computer eight wide tablet column'>
                <div className='ui inverted basic vertical text segment'>
                  <p className='ta interview question'>
                    Auffällig ist, wie viele Frauen als Hundehalter gemeldet
                    sind. Warum?</p>

                  <p className='ta interview'>Ein Hund ist ein Familienmitglied,
                    darum kümmern sich sehr oft die Frauen. </p>

                  <p className='ta interview question'>
                    Der Hund als Baby-Ersatz?</p>

                  <p className='ta interview'>Die wenigsten Leute haben einen
                    Hund als Ersatz für ein Kind. Aber es ist richtig, dass sich
                    die Rolle der Hunde verändert hat. Früher bewachten sie noch
                    Haus und Hof oder übten andere Funktionen aus. Der Chihuahua
                    etwa wurde gezüchtet, um Ratten zu fangen. Vielen kleinen
                    Hunden wird verächtlich nachgesagt, es seien «Schosshunde».
                    Ein Schosshund hatte aber früher eine wichtige Aufgabe. Sie
                    hiessen so, weil es ihre Aufgabe war, den Schoss der adligen
                    Halterin zu beschützen. Diesen Wachinstinkt haben viele noch
                    immer.</p>

                </div>
              </div>
            </div>
          </div>
        </div>

        {
          //endregion

          //region End of Interview
        }

        <div className='ui vertical inverted basic very fitted segment'>
          <div className='ui text container'>
            <p className='ta interview question'>Kläffen kleine Hunde deshalb so
              oft?</p>

            <p className='ta interview'>Generell gilt: Wer sich mehr mit Hunden
              auseinandersetzt, versteht sie besser. Ich bin der Meinung, dass
              es nicht nur für die Halter von grossen Hunden, sondern auch für
              die kleinen Pflicht sein sollte, in die Hundeschule zu gehen.
              Viele kleine Hunde werden nicht artgerecht gehalten und nicht
              verstanden.</p>

            <p className='ta interview question'>Auch in der Stadt Zürich?</p>
            <p className='ta interview'>Kleine Hunde sind mit der grossen,
              lauten Stadt oft überfordert, sie sind auch den Abgasen auf
              Kopfhöhe noch stärker ausgesetzt als grössere Hunde. Ein Leben in
              der Stadt ist stressig und nicht für jeden Hund geeignet, egal
              welche Rasse. </p>

          </div>

        </div>

        {
          //endregion

          //region Vielhundehalterinnen
        }

        <div className='ui vertical inverted basic segment'>
          <div className='ui container'>
            <div className='ui grid'>
              <div className='one column row'>
                <div className='column'>
                  <h2 className='ui tiny infographic inverted dividing header'>
                    Die Vielhundehalterinnen
                  </h2>
                </div>
              </div>
              <div className='three column doubling stackable centered row'>
                <div className='column'>
                  <img src={require('./img/13-dogs.svg')}
                       alt=''
                       className='ui fluid block image'/>
                  <p>Mit 13 Dackeln hält eine ältere Frau aus Wipkingen am
                    meisten Hunde.</p>
                </div>
                <div className='column'>
                  <img src={require('./img/10-dogs.svg')}
                       alt=''
                       className='ui fluid block image'/>
                  <p>Eine Frau aus Altstetten kommt mit 10 Hunden, 5 Chinese
                    Crested und 5 Papillons, an zweiter Stelle.</p>
                </div>
                <div className='column'>
                  <img src={require('./img/8-dogs.svg')}
                       alt=''
                       className='ui fluid block image'/>
                  <p>Auf Platz 3 folgt mit 8 Huskys eine Frau aus Witikon.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          //endregion

          //region Hundenamen
        }
        <div className='ui vertical infographic segment'>
          <div className='ui container'>

            <h2 className='ui inverted tiny infographic dividing header'>
              Die beliebtesten Hundenamen
            </h2>

            <div className='ui inverted divided grid'>

              <div className='two column inverted divided row'>
                <div className='column'>
                  <h3 className='ui tiny inverted header'>
                    <i className='inverted woman icon'></i>
                    Weiblich
                  </h3>

                  <div className='ui three column doubling stackable centered grid'>
                    <div className='column'>
                      <img src={require('./img/name-female-1.svg')}
                           className='ui fluid image'
                           alt='Luna mit 93 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-female-2.svg')}
                           className='ui fluid image'
                           alt='Lucy mit 23 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-female-3.svg')}
                           className='ui fluid image'
                           alt='Lola mit 23 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-female-4.svg')}
                           className='ui fluid image'
                           alt='Kira mit 23 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-female-5.svg')}
                           className='ui fluid image'
                           alt='Daisy mit 22 Registrationen'/>
                    </div>
                  </div>

                </div>

                <div className='column'>
                  <h3 className='ui tiny inverted header'>
                    <i className='inverted man icon'></i>
                    Männlich
                  </h3>

                  <div className='ui three column doubling stackable centered grid'>
                    <div className='column'>
                      <img src={require('./img/name-male-1.svg')}
                           className='ui fluid image'
                           alt='Rocky mit 41 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-male-2.svg')}
                           className='ui fluid image'
                           alt='Max mit 30 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-male-3.svg')}
                           className='ui fluid image'
                           alt='Leo mit 30 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-male-4.svg')}
                           className='ui fluid image'
                           alt='Lucky mit 29 Registrationen'/>
                    </div>
                    <div className='column'>
                      <img src={require('./img/name-male-5.svg')}
                           className='ui fluid image'
                           alt='Snoopy mit 25 Registrationen'/>
                    </div>
                  </div>


                </div>

              </div>


            </div>
          </div>
        </div>

        <div className="ui hidden section divider"></div>


        {
          //endregion

          //region Über Marlen Maurer
        }

        <div className='ui vertical inverted secondary padded segment'>
          <div className='ui container'>
            <div className='ui two column stackable centered grid'>

              <div className='column'>
                <h2 className="ui tiny inverted  infographic header">Zur
                  Person</h2>
                <div className="ui inverted small items">
                  <div className="item">
                    <div className="image">
                      <img src={require('./img/portrait-maurer.jpg')}
                           alt='Portrait Marlen Maurer'
                      />
                    </div>
                    <div className="content">
                      <div className="description">
                        <p><strong>Marlen Maurer</strong>, 40, hat 10 Jahre im
                          Kanton Zürich einen Hundeladen geführt. Seit 2009
                          arbeitet sie mit Hunden und Menschen als
                          Verhaltenstherapeutin.</p>
                      </div>
                      <div className="extra">
                        <a href='http://www.tschigi-school.ch'
                           target='_new'
                           className='ui basic inverted compact right floated button'>
                          <i className='external link icon'></i>
                          Tschigi Hundeschule
                        </a>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="column">
                <h2 className="ui tiny inverted infographic header">
                  Mehr zum Thema
                </h2>

                <a href='http://www.tagesanzeiger.ch/zuerich/stadt/zuerichs-hippster-hund/story/15937436' className="ui text card">
                  <div className="image">
                    <img src="http://files.newsnetz.ch/story/1/5/9/15937436/5/linke_spalte.jpg"
                         alt=""/>
                  </div>
                  <div className="content">
                    <div className="header">Zürichs hippster Hund</div>
                    <div className="meta">Von Martin Sturzenegger</div>
                    <div className="description">Der Chihuahua ist Zürichs
                      Modehund Nummer 1. Der Handel mit den handlichen Tieren
                      boomt – mit teils unliebsamen Folgen.
                    </div>
                    <div className="extra content">
                      <div>Mehr ...</div>
                    </div>
                  </div>
                </a>

              </div>

            </div>
          </div>
        </div>

        {
          //endregion

          //region Impressum
        }

        <div className='ui vertical inverted infographic segment'>
          <div className='ui container'>
            <div className='ui stackable two column middle aligned grid'>
              <div className='column'>
                <table className='ui definition inverted very basic table'>
                  <tr>
                    <td>Quelle</td>
                    <td>Open Data Zürich</td>
                  </tr>
                </table>

                <CopyrightNotice inverted/>
              </div>

              <div className='center aligned column'>
                <StandaloneShareButtons/>
              </div>

            </div>
          </div>
        </div>

        {
          //endregion
        }

        <Tracking articleId="31389254" projectId='chihuahua-land' />

      </div>
    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js